import React, { useEffect, useRef } from 'react';

import moment from 'moment';
import { useState } from 'react';
import {
  selectPrefix,
  selectStationId,
  selectStationName,
  selectUserType,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from '../../utility/Redux/profile';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../../utility/Redux/security';

import {
  selectCollectionAccountDetails,
  setCollectionAccountDetails,
  setItemMasterHelpStatus,
  setListStationMasterModalStatus,
  setSessionExpired,
  setloading,
} from '../../utility/Redux/modal';

import { FormatNumber2, FormatNumber3 } from '../../utility/component/tools';

import { setStationID } from '../../utility/Redux/profile';
import { setStationName } from '../../utility/Redux/profile';
import ModListStationMaster from '../../utility/component/modals/modListStationMaster';
import { FromToDate } from '../../utility/component/fromToDate';
import ItemMasterHelp from '../../master/iteemMasterHelp';
import GeniusReportsDate from '../../utility/component/reportDate';
import ReactToPrint from 'react-to-print';
import GeniusTableForReports from '../../utility/component/geniusComponents/geniusTableforReports';
import dataToLocal from '../../utility/functions/summaryToLocal';
import IsLocalData from '../../utility/functions/ceckLocalData';
import deleteWholeDatabase from '../../utility/functions/deleteWholeDatabase';
import { CallAPIPromise } from './dashboard/biiling/modal/comman';
import ReportDataTable from '../../utility/component/datagrid/ReportDataTable';
import {
  Boxes,
  MapPin,
} from 'lucide-react';

function ReportCard({ data, rows }) {
  const cards = [
    { label: 'Items', value: rows.length, tone: 'bg-slate-100 text-slate-700' },
    { label: 'Issue Qty', value: FormatNumber3(rows.reduce((t, r) => t + Number(r.IQNTY || 0), 0)), tone: 'bg-blue-50 text-blue-700' },
    { label: 'Issue Amount', value: FormatNumber2(rows.reduce((t, r) => t + Number(r.IAMOUNT || 0), 0)), tone: 'bg-indigo-50 text-indigo-700' },
    { label: 'Return Qty', value: FormatNumber3(rows.reduce((t, r) => t + Number(r.RQNTY || 0), 0)), tone: 'bg-amber-50 text-amber-700' },
    { label: 'Collection', value: FormatNumber2(data?.COLLECTION || 0), tone: 'bg-emerald-50 text-emerald-700' },
    { label: 'Balance', value: FormatNumber2(data?.BALANCE || 0), tone: 'bg-rose-50 text-rose-700' },
  ];

  return (
    <section className="grid grid-cols-2 gap-3 lg:grid-cols-3 xl:grid-cols-6">
      {cards.map((card) => (
        <div key={card.label} className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{card.label}</p>
          <p className={`mt-2 truncate rounded-lg px-2 py-1 text-lg font-bold ${card.tone}`}>{card.value}</p>
        </div>
      ))}
    </section>
  );
}

const ItemWiseIssueReport = () => {
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);
  const ReduxStation_id = useSelector(selectStationId);
  const dispatch = useDispatch();
  const ReduxStationName = useSelector(selectStationName);
  const printRef = useRef();
  const [calculationData,setCalcultationData]= useState("")
  const userType = useSelector(selectUserType);
  const firstDate = useSelector(selectreportFromDate);
  const SecondDate = useSelector(selectreportToDate);
  const [dataLoading, setDataLoading] = useState(false);
  const [list, setList] = useState([]);
  const [itemCode, setItemCode] = useState('');
  const accDetails = useSelector(selectCollectionAccountDetails);
  const width = useSelector(selectWidth);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const [toDateFocus, setToDateFocus] = useState(false);

  const getItemWiseReport = () => {
    setCalcultationData('')
    setDataLoading(true);
    deleteWholeDatabase('item_Wise_issue_report');
    CallAPIPromise(
      `/api/issueStockReports/itemWiseIssueReport`,
      {
        table_prefix: prefix,
        FDATE: firstDate,
        TDATE: SecondDate,
        SID: ReduxStation_id,
      },
      token,
      dispatch
    )
      .then((res) => {
        if (!res.data.error) {
          const data = res.data.response;
          let rowList = [];
          if (res.data.day_end_sum[0] ) {
            setCalcultationData(res.data.day_end_sum[0] )

        }
          for (let index = 0; index < data.length; index++) {
            rowList.push({
              ...data[index],
              id: index + 1,
            });
          }
          if (rowList[0]) {
            dataToLocal('item_Wise_issue_report', rowList, [
              {
                table_prefix: prefix,
                from_date: firstDate,
                to_date: SecondDate,
                SID: ReduxStation_id,
                ICODE: itemCode ? itemCode : '',
                ACCOUNT_NO: accDetails.accNumber ? accDetails.accNumber : '',
              },
            ]);
          }
          setList(rowList);
        }
      })
      .catch((e) => {
        console.log(e);

        if (e.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setloading(false));
        setDataLoading(false);
      });
  };
  const okButton = () => {
    getItemWiseReport();
  };

  const columns = [
    {
      field: 'ICODE',
      type: 'number',
      accessor: 'ICODE',
      width: width < 1280 ? 100 : 100,
      headerAlign: 'center',
      align: 'left',
      valueFormatter: (param) => {
        return param.value;
      },
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex text-center">
          {' '}
          {'Code'}
        </div>
      ),
    },

    {
      field: 'INAME',
      accessor: 'INAME',
      type: 'string',
      width: width < 1280 ? 150 : 200,
      headerAlign: 'center',
      align: 'left',

      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4 flex text-center"
        >
          {'Item Name'}
        </div>
      ),
    },

    {
      field: 'IQNTY',
      accessor: 'IQNTY',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber3(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Issue Qnty'}</div>
      ),
    },
    {
      field: 'IAMOUNT',
      accessor: 'IAMOUNT',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Issue Amount'}</div>
      ),
    },
    {
      field: 'RQNTY',
      accessor: 'RQNTY',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber3(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Return Qnty'}</div>
      ),
    },
    {
      field: 'RAMOUNT',
      accessor: 'RAMOUNT',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Return Amt.'}</div>
      ),
    },
    {
      field: 'SQNTY',
      accessor: 'SQNTY',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber3(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Sale Qnty'}</div>
      ),
    },
    {
      field: 'SAMOUNT',
      accessor: 'SAMOUNT',
      type: 'string',
      width: width < 1280 ? 100 : 100,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Sale Amount'}</div>
      ),
    },
  ];
  const totalIQnty = list.reduce((total, row) => total + Number(row.IQNTY || 0), 0);
  const totalIAMT = list.reduce((total, row) => total + Number(row.IAMOUNT || 0), 0);
  const totalRQnty = list.reduce((total, row) => total + Number(row.RQNTY || 0), 0);
  const totalRAMT = list.reduce((total, row) => total + Number(row.RAMOUNT || 0), 0);
  const totalSaleQnty = list.reduce((total, row) => total + Number(row.SQNTY || 0), 0);
  const totalSAMT = list.reduce((total, row) => total + Number(row.SAMOUNT || 0), 0);

  useEffect(() => {
    const callback = (details, data) => {
      setList(data);
      dispatch(setStationID(details[0].SID));
      dispatch(setItemCode(details[0].ICODE));
      dispatch(
        setreportsTodate(moment(details[0].to_date).format('YYYY-MM-DD'))
      );

      dispatch(
        setreportsFromDate(moment(details[0].from_date).format('YYYY-MM-DD'))
      );
    };
    const elseFunc = () => {
      if (userType !== 'USER') {
        dispatch(setStationID(''));
        dispatch(setStationName(''));
      }
    };
    IsLocalData('item_Wise_issue_report', callback, elseFunc);
  }, [dispatch, userType]);


  return (
    <div className="h-full w-full overflow-auto bg-slate-50 p-3 sm:p-5">
      <section className="mb-4 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="flex flex-col gap-4 border-b border-slate-100 px-5 py-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-start gap-3">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-100 text-amber-700">
              <Boxes size={22} />
            </div>
            <div>
              <h1 className="text-xl font-bold tracking-tight text-slate-900">Item Wise Issue Report</h1>
              <p className="mt-1 text-sm text-slate-500">Compare issued, returned and sold quantities by item.</p>
            </div>
          </div>
          <div className="flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-sm text-slate-600">
            <MapPin size={16} className="text-slate-400" />
            <span className="text-slate-500">Station:</span>
            <span className="max-w-[220px] truncate font-semibold text-slate-800">
              {ReduxStationName || ReduxStation_id || 'All stations'}
            </span>
          </div>
        </div>
        <div className="p-3">
      {window.innerWidth <= 500 ? (
        <>
          <div
            style={{
              border: '1px solid #b5b3b3',
            }}
            className="p-1 py-3 rounded-t-sm  flex items-center "
          >
            <div className="px-1 ">From</div>

            <GeniusReportsDate
              date={firstDate}
              onChange={(e) => {
                dispatch(setreportsFromDate(moment(e).format('YYYY-MM-DD')));
                setFromDateFocus(false);
              }}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="px-1 pl-2 ">To</div>
            <GeniusReportsDate
              date={SecondDate}
              onChange={(e) => {
                dispatch(setreportsTodate(moment(e).format('YYYY-MM-DD')));
                setToDateFocus(false);
              }}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>

          <div style={{ border: '1px solid #b5b3b3', borderTop: '0px' }}>
            {userType === 'USER' ? null : (
              <div className="flex  text-[#4B4545] p-2  ">
                <div
                  onClick={() => {
                    if (userType === 'MANAGER' ||userType === 'STORE' ) {
                      dispatch(setListStationMasterModalStatus(true));
                    }
                  }}
                  style={{ fontSize: 13 }}
                  className=" flex whitespace-normal  justify-center items-center hover:cursor-pointer "
                >
                  <div className="flex items-center ">
                    <div>
                      <i
                        className="bi bi-search"
                        style={{ color: '#f44336', fontSize: 15 }}
                      ></i>
                    </div>

                    <span
                      style={{ fontSize: 12, fontWeight: 600 }}
                      className=" text-[#5c5b5b] pl-2 whitespace-nowrap  items-center"
                    >
                      Station ID
                    </span>
                  </div>

                  <div
                    style={{
                      border: '1px dotted #a6a2a2 ',
                      borderRadius: '3px',
                    }}
                    className="flex text-[#a6a2a2]  pl-2 ml-3  "
                  >
                    <input
                      size={'small'}
                      placeholder="All"
                      value={ReduxStation_id ? ReduxStation_id : 'All'}
                      style={{
                        // width: '20%',
                        fontSize: 13,
                        paddingTop: '2px',
                        paddingBottom: '2px',
                        backgroundColor: 'transparent',
                      }}
                      readOnly
                      className=" outline-0 w-6"
                    />

                    <div
                      style={{
                        borderLeft: '1px dotted #a6a2a2 ',
                      }}
                      className="px-2 p-1 w-52 whitespace-nowrap print:hidden"
                    >
                      {ReduxStationName ? `${ReduxStationName}` : null}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="pb-2">
              <button
                onClick={okButton}
                className="flex items-center rounded-sm ml-2"
                style={{
                  backgroundColor: '#c1c1c1',
                  paddingLeft: 30,
                  paddingRight: 30,
                  paddingTop: 4,
                  paddingBottom: 4,
                  color: 'black',
                }}
              >
                <div className="flex items-center text-sm">Ok</div>
              </button>
            </div>
          </div>
        </>
      ) : (
        <FromToDate
          submit={okButton}
          otherButton={
            list[0] && width > 1024 ? (
              <ReactToPrint
                trigger={() => {
                  return (
                    <button
                      style={{
                        width: 'auto',
                        borderRadius: '7px',
                        height: 'auto',
                        paddingLeft: 30,
                        paddingRight: 30,
                        paddingTop: 4,
                        paddingBottom: 4,
                        backgroundColor: '#bad4f9',
                        color: 'black',
                        marginLeft: 7,
                      }}
                    >
                      <div className="text-sm">Print</div>
                    </button>
                  );
                }}
                content={() => printRef.current}
              />
            ) : (
              false
            )
          }
          reset={() => {
            if (userType === 'USER') {
              dispatch(
                setCollectionAccountDetails({
                  accName: '',
                  accAddress: '',
                  accMobile: '',
                  accNumber: '',
                  stationId: '',
                })
              );
              setItemCode('');
            } else {
              setItemCode('');
              dispatch(setStationID(''));
              dispatch(setStationName(''));
              dispatch(
                setCollectionAccountDetails({
                  accName: '',
                  accAddress: '',
                  accMobile: '',
                  accNumber: '',
                  stationId: '',
                })
              );
            }
          }}
        />
      )}
        </div>
      </section>
      <ReportCard data={calculationData} rows={list} />
      <div
        style={{
          marginTop: 10,
          minHeight: 520,
        }}
        className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
      >
        <ReportDataTable
          columns={columns}
          rows={list}
          loading={dataLoading}
          getRowKey={(row) => row.id}
          emptyTitle="No item wise issue data found"
          emptyDescription="Select filters and run the report to view item issue details."
          footerValue={(column) => {
            if (column.field === 'INAME') return 'Grand Total';
            if (column.field === 'IQNTY') return FormatNumber3(totalIQnty);
            if (column.field === 'IAMOUNT') return FormatNumber2(totalIAMT);
            if (column.field === 'RQNTY') return FormatNumber3(totalRQnty);
            if (column.field === 'RAMOUNT') return FormatNumber2(totalRAMT);
            if (column.field === 'SQNTY') return FormatNumber3(totalSaleQnty);
            if (column.field === 'SAMOUNT') return FormatNumber2(totalSAMT);
            return '';
          }}
        />
      </div>

      {width <= 1024 && (
        <div className="w-full flex justify-end mt-2">
          <ReactToPrint
            trigger={() => {
              return (
                <button
                  style={{
                    width: 'auto',
                    borderRadius: '7px',
                    height: 'auto',
                    padding: 10,
                    backgroundColor: '#bad4f9',
                    color: 'black',
                  }}
                >
                  Print Report
                </button>
              );
            }}
            content={() => printRef.current}
          />
        </div>
      )}
      <div
        ref={printRef}
        className="hidden w-full print:block"
      >
        <GeniusTableForReports
          stationId={ReduxStation_id}
          date={firstDate}
          date1={SecondDate}
          columns={columns}
          data={list}
         
          Fotter={
            <div className="mt-6 border-t border-gray-400 pt-3 text-sm print:text-xs text-gray-800">
       
          
              {/* Totals Table */}
              <div className="grid grid-cols-2 gap-y-2 gap-x-10 max-w-lg ml-auto">
                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Total Issue Qty</span>
                  <span className="font-semibold text-right w-28">
                    {list.reduce((t, r) => t + Number(r.IQNTY || 0), 0)}
                  </span>
                </div>
          
                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Total Issue Amount</span>
                  <span className="font-semibold text-right w-28">
                    {FormatNumber2(list.reduce((t, r) => t + Number(r.IAMOUNT || 0), 0))}
                  </span>
                </div>
          
                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Total Return Qty</span>
                  <span className="font-semibold text-right w-28">
                    {list.reduce((t, r) => t + Number(r.RQNTY || 0), 0)}
                  </span>
                </div>

                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Total Return Amount</span>
                  <span className="font-semibold text-right w-28">
                    {FormatNumber2(list.reduce((t, r) => t + Number(r.RAMOUNT || 0), 0))}
                  </span>
                </div>


                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Cash</span>
                  <span className="font-semibold text-right w-28">
                    {FormatNumber2(calculationData?.CASH || 0)}
                  </span>
                </div>
          
                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Less</span>
                  <span className="font-semibold text-right w-28">
                    {FormatNumber2(calculationData?.LESS || 0)}
                  </span>
                </div>
          
                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Expense</span>
                  <span className="font-semibold text-right w-28">
                    {FormatNumber2(calculationData?.EXPENSE || 0)}
                  </span>
                </div>
          
                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Debit</span>
                  <span className="font-semibold text-right w-28">
                    {FormatNumber2(calculationData?.DEBIT || 0)}
                  </span>
                </div>
              
                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Collection</span>
                  <span className="font-semibold text-right w-28">
                    {FormatNumber2(calculationData?.COLLECTION || 0)}
                  </span>
                </div>

                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Due</span>
                  <span className="font-semibold text-right w-28">
                    {FormatNumber2(calculationData?.DUE || 0)}
                  </span>
                </div>

                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Total Sale Qnty.</span>
                  <span className="font-semibold text-right w-28">
                    {list.reduce((t, r) => t + Number(r.SQNTY || 0), 0)}
                  </span>
                </div>

                <div className="flex justify-between border-b border-dashed border-gray-300 pb-1">
                  <span className="font-medium">Total Sale Amt.</span>
                  <span className="font-semibold text-right w-28">
                  {FormatNumber2( list.reduce((t, r) => t + Number(r.SAMOUNT || 0), 0))}

                  </span>
                </div>
              </div>
          
              {/* Highlighted Balance Row */}
              <div className="flex justify-between mt-3 border-t-2 border-gray-600 pt-2 font-bold text-gray-900 max-w-lg ml-auto">
                <span>Balance</span>
                <span className="text-right w-28">
                  {FormatNumber2(calculationData?.BALANCE || 0)}
                </span>
              </div>
            </div>
          }
          
          
          title={'Item Wise Issue Report'}
        />
      </div>

      <ModListStationMaster
        onRowClick={(p) => {
          dispatch(setStationID(p.row.CODE));
          dispatch(setStationName(p.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
      <ItemMasterHelp
        onRowClick={(p) => {
          setItemCode(p.row.ICODE);
          dispatch(setItemMasterHelpStatus(false));
        }}
        setItemCode={setItemCode}
      />
    </div>
  );
};

export default ItemWiseIssueReport;
